import { render, staticRenderFns } from "./ModalWhitelistSubmissionConfirmation.vue?vue&type=template&id=0fe18ccd&scoped=true&"
import script from "./ModalWhitelistSubmissionConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalWhitelistSubmissionConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalWhitelistSubmissionConfirmation.vue?vue&type=style&index=0&id=0fe18ccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe18ccd",
  null
  
)

export default component.exports